// extracted by mini-css-extract-plugin
export var banner = "_2n-0";
export var icon = "_2n-1";
export var message = "_2n-2";